export default "__VITE_ASSET__DeChRFa2__"